define('common/components/nunjucks-config/nunjucks-filters',[
        'moment',
        'i18next'
    ], function(moment, i18next) {
    'use strict';

    var escapeChars = {
      'lt': '<',
      'gt': '>',
      'quot': '"',
      'apos': "'",
      'amp': '&'
    };

    /**
     * unescapeHTML function needed to resolve double escaping issue with
     * stripTags filter. The Flask version of striptags unescapes input
     * after stripping HTML tags on the backend so that autoescape can run
     * without double escaping. We need to do the same here on the frontend
     * instead of misusing safe filter in Jinja2 templates before they are
     * precompiled by Nunjucks.
     *
     * Using underscore.string implementation of unescapeHTML
     */
    function unescapeHTML(str) {
      return ('' + str).replace(/\&([^;]+);/g, function(entity, entityCode){
        var match;

        if (entityCode in escapeChars) {
          return escapeChars[entityCode];
        } else if (match = entityCode.match(/^#x([\da-fA-F]+)$/)) {
          return String.fromCharCode(parseInt(match[1], 16));
        } else if (match = entityCode.match(/^#(\d+)$/)) {
          return String.fromCharCode(~~match[1]);
        } else {
          return entity;
        }
      });
    }

    var njxFilters = {
        "thousands": function(num) {
            return num.toLocaleString('en-US');
        },

        "styleThumbnailFor": function(thumbs, size){
            var thumbnail = _.findWhere(thumbs, {"size": size});
            if (thumbnail){
                return "background-image: url('" + thumbnail.url + "');";
            }
            return '';
        },

        "thumbnailUrlFor": function(thumbs, size){
            var thumbnail = _.findWhere(thumbs, {"size": size});
            return thumbnail ? thumbnail.url : "";
        },

        "imageUrlFor": function(image, size){
            var image = _.findWhere(image, {"size": size});
            return image ? image.url : "";
        },

        "searchAssetType": function(type){
            var className,
                typeName = type.name,
                groupId = type.group_id;
            switch (groupId) {
                case 2: // VIEW asset group
                    if (typeName === "Full Video" || typeName === "Video Segment") {
                        className = "video";
                    } else {
                        className = "image";
                    }
                    break;
                case 5: // LISTEN asset group
                    className = "audio";
                    break;
                case 6: // READ asset group
                    className = "text";
                    break;
                case 7: // INTERACT asset group
                    className = "interactive";
                    break;
                case 8: // TEACH asset group
                    if (typeName === "Review Sheet" || typeName === "Assessment" || typeName === "Assignment" ||
                        typeName === "Technology Enhanced Assessment" || typeName === "Constructed Response" ||
                        typeName === "Quiz" || typeName === "Writing Prompt") {
                        className = "assess";
                    } else {
                        className = "material";
                    }
                    break;
                case 10: // TEACH asset group
                    className = "material";
                    break;
                default:
                    className = "image";
            }
            return className;
        },

        "formatGradesForTemplate": function(grades){
            var gradeBands = [],
                i;
            for (i = 0; i < grades.length; i++) {
                if (gradeBands.indexOf(grades[i].grade_band) === -1) {
                    gradeBands.push(grades[i].grade_band);
                }
            }
            return gradeBands.join(", ");
        },

        "secondsToHhmmss": function(str){
            var d = Number(str),
                h = Math.floor(d / 3600),
                m = Math.floor(d % 3600 / 60),
                s = Math.floor(d % 3600 % 60),
                retString = "";
                if (h > 0){
                    retString += h + ":";
                }
                if (m === 0) {
                    retString += "00:";
                } else if (m < 10){
                    retString += "0" + m + ":";
                } else {
                    retString += m + ":";
                }
            return retString + (s < 10 ? "0" : "") + s;
        },

        "percent": function (part, whole, round_places) {
            var percentage = 0,
                multiplier;

            part = part || 0;
            whole = whole || 0;

            if (!round_places && round_places !== 0) {
                round_places = 2;
            }

            round_places = Math.floor(round_places);
            multiplier = Math.pow(10, round_places);

            if (whole === 0) {
                return percentage;
            }

            percentage = (part * 100) / whole; // eslint-disable-line no-extra-parens
            percentage = Math.round(percentage * multiplier) / multiplier;

            return percentage;
        },

        "time_ago": function(date_string) {
            var date = moment(date_string);
            date.lang(i18next.language);
            return date.fromNow();
        },

        /* Flask filters */
        "toJSON": function(obj){
            return JSON.stringify(obj);
        },

        "stripTags": function(str){
            var stripped = str.replace(/(<([^>]+)>)/ig, "");
            return unescapeHTML(stripped);
        },

        "is_media_asset": function(type_id) {
            if (type_id === '3123b3ad-3c2d-49cf-92ce-9927c3c09e64' || type_id === '1aa883f4-b310-4a5a-9d35-d07dc8cadf6c' || type_id === 'b2ae1c36-4265-46d4-b8d0-f430d6e1357e' || type_id === '13f26cf6-734e-40a7-8be0-b43cccc36d24' || type_id === 'b373b9c1-fe6d-4891-9ff3-3b59b23550e2') {
                return true;
            } else {
                return false;
            }
        },

        "is_image_asset": function(type_id) {
            if (type_id === '1aa883f4-b310-4a5a-9d35-d07dc8cadf6c' || type_id === '3123b3ad-3c2d-49cf-92ce-9927c3c09e64') {
                return true;
            } else {
                return false;
            }
        },

        "is_video_segment_asset": function(type_id) {
            if (type_id === 'b2ae1c36-4265-46d4-b8d0-f430d6e1357e' || type_id === '13f26cf6-734e-40a7-8be0-b43cccc36d24') {
                return true;
            } else {
                return false;
            }
        },

        "is_full_video_asset": function(type_id) {
            if (type_id === 'b373b9c1-fe6d-4891-9ff3-3b59b23550e2') {
                return true;
            } else {
                return false;
            }
        },

        "is_array": function(obj) {
            return Array.isArray(obj);
        },

        "grade_bands": function(grades) {
            var grade_band_list = [];

            grades = grades.map(function (i) {
                return i.grade_band;
            });

            for (var i = 0, len = grades.length; i < len; i++) {
                if (grade_band_list.indexOf(grades[i]) === -1) {
                    grade_band_list.push(grades[i]);
                }
            }

            return grade_band_list;
        },

        "alnum": function(string) {
            return string.replace(/\W/g, '');
        },

        "find_where": function (list, props) {
            return _.findWhere(list, props) || null;
        },

        "imageDirectory": function(guid){
            return (guid.substr(0, 2) + "/" + guid.substr(2, 2) + "/").toLowerCase();
        },

        "hyphenate": function(asset_type) {
            return asset_type.replace(/\W/g, '-');
        },

        "fromisoformat": function(dateString) {
            return new Date(dateString);
        },

        "strftime": function(date, format) {
            if (document.documentElement.lang && ['en_GB', 'sv'].indexOf(document.documentElement.lang) > -1) {
                // We want to skip anything that is ISO86-ish (year followed by month)
                var iso86_re = /%[yY].?%-?[mbB]/;
                if (format.match(iso86_re) === null) {
                    var swaps = [
                        ['%m%d', '%d%m'],
                        ['%m %d', '%d %m'],
                        ['%m,%d', '%d,%m'],
                        ['%m/%d', '%d/%m'],
                        ['%m_%d', '%d_%m'],
                        ['%m-%d', '%d-%m'],
                        ['%m%-d', '%-d%m'],
                        ['%m %-d', '%-d %m'],
                        ['%m,%-d', '%-d,%m'],
                        ['%m/%-d', '%-d/%m'],
                        ['%m_%-d', '%-d_%m'],
                        ['%m-%-d', '%-d-%m'],
                        ['%-m%d', '%d%-m'],
                        ['%-m %d', '%d %-m'],
                        ['%-m,%d', '%d,%-m'],
                        ['%-m/%d', '%d/%-m'],
                        ['%-m_%d', '%d_%-m'],
                        ['%-m-%d', '%d-%-m'],
                        ['%-m%-d', '%-d%-m'],
                        ['%-m %-d', '%-d %-m'],
                        ['%-m,%-d', '%-d,%-m'],
                        ['%-m/%-d', '%-d/%-m'],
                        ['%-m_%-d', '%-d_%-m'],
                        ['%-m-%-d', '%-d-%-m'],
                        ['%b %d,', '%d %b'],
                        ['%B %d,', '%d %B']
                    ];

                    for (var i = 0, len = swaps.length; i < len; i++) {
                        if (format.indexOf(swaps[i][0]) > -1) {
                            format = format.replace(swaps[i][0], swaps[i][1]);
                            break;
                        }
                    }
                }
            }



            // https://github.com/benjaminoakes/moment-strftime/blob/master/lib/moment-strftime.js
            var replacements = {
                'a': 'ddd',
                'A': 'dddd',
                'b': 'MMM',
                'B': 'MMMM',
                'd': 'DD',
                'e': 'D',
                'F': 'YYYY-MM-DD',
                'H': 'HH',
                'I': 'hh',
                'j': 'DDDD',
                'k': 'H',
                'l': 'h',
                'm': 'MM',
                'M': 'mm',
                'p': 'A',
                'S': 'ss',
                'u': 'E',
                'w': 'd',
                'W': 'WW',
                'y': 'YY',
                'Y': 'YYYY',
                'z': 'ZZ',
                'Z': 'z',
                '%': '%'
            },
            momentFormat, value;

            // Convert sequences of letters to bracket-enclosed moment format literals
            momentFormat = format.replace(/[^%](\w+)/g, function (literal) { return '[' + literal + ']'; });

            Object.keys(replacements).forEach(function (key) {
              value = replacements[key];
              momentFormat = momentFormat.replace("%" + key, value);
            });

            return moment(date).utc().format(momentFormat);
        },

        "index_of": function (source_list, search_item) {
            return source_list.indexOf(search_item);
        },

        "n2e": function (input_string) {
            if (typeof input_string === "undefined" || input_string === null) {
                return "";
            } else {
                return input_string;
            }
        },

        "key_not_none": function(input_dict, key){
            if (key in input_dict){
                return (input_dict[key] !== null && input_dict[key] !== void 0);
            }
            return false;
        },

        "media_file_metadata": function (media_file) {
            var related_media_file_formats,
                media_file_metadata,
                media_file_format;

            media_file_metadata = {
                "default_title_override": null,
                "is_obsolete": false,
                "is_pdf_document": false,
                "is_related_media": false,
                "is_teacher_only": false
            };

            // DEVELOPER NOTES:
            // ===============
            //
            // This list needs to be updated whenever
            // a new related-media file is added, updated, or,
            // deleted from the DB.
            //
            // Sometimes a media-file format is made obsolete
            // and, removed from the DB table. This does NOT
            // remove it from the frozen-courses mongo documents,
            // and, may still need to be kept in this list to keep
            // the TB templates used on frozen courses from
            // throwing fatal errors.
            //
            related_media_file_formats = {
                // Teacher Guide
                "6": {
                    "default_title_override": null,
                    "file_extensions": [ 'pdf' ],
                    "is_obsolete": false,
                    "is_teacher_only": true
                },

                // General Word Document
                "7": {
                    "default_title_override": null,
                    "file_extensions": [ 'doc', 'docx' ],
                    "is_obsolete": false,
                    "is_teacher_only": false
                },

                // Student Guide
                "8": {
                    "default_title_override": null,
                    "file_extensions": [ 'pdf' ],
                    "is_obsolete": false,
                    "is_teacher_only": false
                },

                // Excel Work Sheet
                "39": {
                    "default_title_override": null,
                    "file_extensions": [ 'xls' ],
                    "is_obsolete": false,
                    "is_teacher_only": false
                },

                // PDF Version
                "51": {
                    "default_title_override": i18next.t('PDF Version'),
                    "file_extensions": [ 'pdf' ],
                    "is_obsolete": true,
                    "is_teacher_only": false
                }
            };


            if (media_file.format_id.toString() in related_media_file_formats) {
                media_file_format = related_media_file_formats[media_file.format_id.toString()];

                _.extend(media_file_metadata, {
                    "default_title_override": media_file_format.default_title_override,
                    "is_obsolete": media_file_format.is_obsolete,
                    "is_pdf_document": media_file_format.file_extensions.indexOf('pdf') > -1,
                    "is_related_media": true,
                    "is_teacher_only": media_file_format.is_teacher_only
                });

                if (media_file_format.default_title_override) {
                    media_file_metadata.default_title_override = media_file_format.default_title_override;
                }
            }

            return media_file_metadata;
        },

        "video_file_res": function (formatId) {
            switch (formatId) {
            case 34:
                return 'Standard';

            case 35:
                return 'High';

            case 53:
                return 'Adaptive';

            default:
                return '';
            }
        },

        "video_file_type": function (formatId) {
            switch (formatId) {
            case 34:
                return 'video/mp4';

            case 35:
                return 'video/mp4';

            case 53:
                return 'application/x-mpegURL';

            default:
                return '';
            }
        },

        "query_string": function (url) {
            var newParams = [].slice.call(arguments, 1),
                combinedParams,
                encodedParams = [],
                hash,
                oldParams = {},
                queryString,
                splitUrl,
                urlBase;

            // Set the hash aside
            splitUrl = url.split('#');
            url = splitUrl[0];
            hash = splitUrl[1] || '';

            // Set the url base aside
            splitUrl = url.split('?');
            urlBase = splitUrl[0];

            if (splitUrl[1]) {
                // The url already carries query params
                oldParams = njxFilters.query_string_to_dict(splitUrl[1]);
            }

            // Combine the old params with all new params we've passed in
            combinedParams = _.reduce(newParams, function (memo, paramObj) {
                return _.extend(memo, paramObj);
            }, oldParams);

            // Encode all the params
            _.each(Object.keys(combinedParams), function (key) {
                var val = combinedParams[key];

                // Allow values to be overridden or excluded
                if (typeof val === 'undefined' || val === null) {
                    return;
                }

                if (Array.isArray(val)) {
                    // Encode arrays as key=val1&key=val2&key=val3 for Flask
                    _.each(val, function (arrVal) {
                        encodedParams.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrVal));
                    });
                } else {
                    // Encode anything else as key=val
                    encodedParams.push(encodeURIComponent(key) + '=' + encodeURIComponent(val));
                }
            });

            queryString = encodedParams.join('&');

            // Return the complete url: base, query and hash
            return urlBase
                + (queryString ? '?' + queryString : '')
                + (hash ? '#' + hash : '');
        },

        "query_string_to_dict": function (str) {
            var params = {};

            // Remove leading ? if necessary
            if (str.indexOf('?') !== -1) {
                str = str.split('?')[1];
            }

            _.each(str.split('&'), function (queryStr) {
                var splitQueryStr = queryStr.split('='),
                    key = splitQueryStr[0],
                    val = splitQueryStr[1];

                // Ignore empty params
                if (!key || !val) {
                    return;
                }

                // Decode elements
                key = decodeURIComponent(key);
                val = decodeURIComponent(val);

                // Parsed params are always stored as an array to match the python version
                if (params[key]) {
                    params[key].push(val);
                } else {
                    params[key] = [val];
                }
            });

            return params;
        },

        "shuffle": function (list) {
            return _.shuffle(list);
        },

        "where": function (list, props) {
            return _.where(list, props) || [];
        },

        "title": function (string) {
            var fullFirstName = string.split(' ');

            return fullFirstName.map(function(name) {
                var first = name.substring(0, 1);
                var rest = name.substring(1, name.length);
                return first.toUpperCase() + rest.toLowerCase();
            }).join(' ');
        }
    };

    return njxFilters;

});

